export const SET_LOADING_DATA = '@loadType/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@loadType/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@loadType/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@loadType/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@loadType/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@loadType/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@loadType/SAVE_REQUEST';
export const SAVE_SUCCESS = '@loadType/SAVE_SUCCESS';

export const DELETE_ITEM = '@loadType/DELETE_ITEM';
export const EDIT_ITEM = '@loadType/EDIT_ITEM';

export const SEARCH = '@loadType/SEARCH';

export const SET_PAGE = '@loadType/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@loadType/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@loadType/SET_ORDER';
export const SET_ORDERBY = '@loadType/SET_ORDEBY';
